var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@/inversify.config';
import { AiTaggingTourApi } from './types/ai-tagging-tour-api.interface';
let AiTaggingTourServiceImpl = class AiTaggingTourServiceImpl {
    constructor(aiTaggingTourApi) {
        this.aiTaggingTourApi = aiTaggingTourApi;
    }
    getSpaceList(params) {
        return this.aiTaggingTourApi.getSpaceList(params);
    }
};
AiTaggingTourServiceImpl = __decorate([
    injectable(),
    __param(0, inject(AiTaggingTourApi)),
    __metadata("design:paramtypes", [typeof (_a = typeof AiTaggingTourApi !== "undefined" && AiTaggingTourApi) === "function" ? _a : Object])
], AiTaggingTourServiceImpl);
export { AiTaggingTourServiceImpl };
